// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Some UI strings are rendered from a "specialized" translation key whose English
// default differs from the plain string a library actually translates in the Summon
// Admin Console. Custom translations are keyed by the plain visible text, so they land
// on the base key and never reach the specialized key. Languages with a Summon built-in
// catalog (de, fr-FR, es, it) work because the catalog ships the specialized key already
// translated, but customer-only locales (fr-CA, he, zh) do not.
//
// This map declares `specializedKey -> { base, styleNumber }`. When the specialized key
// was not translated by the merge but the base key was, we copy the base translation onto
// the specialized key. Explicit translations of the specialized key always win.
//
//   - Year preset links (1 year / 3 years / ...) embed <font class='font-year'> markup
//     in their defaults; libraries translate the plain DATE_PRESET_* strings. When we
//     borrow that plain translation we wrap its leading number in the same markup so the
//     number renders on its own line with the unit below (e.g. "10" above "ans").
//   - "Open Access" is rendered from disambiguated keys on the result indicator, the
//     facet-panel quick filter and advanced search, whose defaults carry a
//     "(Indicator)" / "(Filter)" suffix; libraries translate the base "Open Access".
const TRANSLATION_KEY_FALLBACKS: { [specializedKey: string]: { base: string, styleNumber?: boolean } } = {
   _1_YEAR: { base: 'DATE_PRESET_1Y', styleNumber: true },
   _3_YEARS: { base: 'DATE_PRESET_3Y', styleNumber: true },
   _5_YEARS: { base: 'DATE_PRESET_5Y', styleNumber: true },
   _10_YEARS: { base: 'DATE_PRESET_10Y', styleNumber: true },
   OPEN_ACCESS_FILTER: { base: 'OPEN_ACCESS' },
   OPEN_ACCESS_INDICATOR: { base: 'OPEN_ACCESS' }
}

class TranslationService {
   $translationKeys: any
   lookup: any
   translatedCache: any
   translations: any
   constructor($translationKeys: any) {
      this.$translationKeys = $translationKeys
      this.translatedCache = []
      this.translations = this.$translationKeys
      // @ts-expect-error TS(2339) FIXME: Property '__translations' does not exist on type '... Remove this comment to see the full error message
      this.lookup = window.__translations || {}

      // Capture the English defaults before the in-place merge below mutates them,
      // so we can tell afterwards which keys were actually translated.
      const originalDefaults: { [key: string]: any } = {}
      angular.forEach(TRANSLATION_KEY_FALLBACKS, (fallback: any, specializedKey: string) => {
         originalDefaults[specializedKey] = this.translations[specializedKey]
         originalDefaults[fallback.base] = this.translations[fallback.base]
      })

      angular.forEach(this.translations, (value: any, key: any) => {
         return angular.forEach(this.lookup, (t: any, k: any) => {
            if ((value === k) && (t !== null)) {
               return this.translations[key] = t
            }
         })
      })

      this.applyKeyFallbacks(originalDefaults)
   }

   /**
    * Ensure custom (Summon Admin Console) translations of a base string are shown on
    * specialized keys that render the same concept (see TRANSLATION_KEY_FALLBACKS).
    * If a specialized key was not translated by the merge above but its base key was,
    * fall back to the base translation. Specialized keys that were translated (English
    * default or a built-in catalog such as German) are left untouched.
    */
   applyKeyFallbacks(originalDefaults: { [key: string]: any }) {
      angular.forEach(TRANSLATION_KEY_FALLBACKS, (fallback: any, specializedKey: string) => {
         const baseKey = fallback.base
         const specializedWasTranslated = this.translations[specializedKey] !== originalDefaults[specializedKey]
         const baseWasTranslated = this.translations[baseKey] !== originalDefaults[baseKey]
         if (!specializedWasTranslated && baseWasTranslated) {
            let value = this.translations[baseKey]
            if (fallback.styleNumber) { value = this.styleLeadingNumber(value) }
            this.translations[specializedKey] = value
         }
      })
   }

   /**
    * Wrap the leading number in the text with the same markup the English year-preset
    * labels use, so the number is rendered on its own line (via the `.font-year` block
    * style) with the unit below it, e.g. "10 ans" -> "<font class='font-year'>10</font> ans".
    * The match is anchored to the start (optional leading whitespace preserved) so only the
    * leading number is styled — a digit sequence appearing later in the text is left alone.
    * Text without a leading number is returned unchanged.
    */
   styleLeadingNumber(text: any) {
      if (typeof text !== 'string') { return text }
      return text.replace(/^(\s*)(\d+)/, "$1<font class='font-year'>$2</font>")
   }

   translate(text: any, substitutions = {}) {
      let translated
      const tmpKey = text + JSON.stringify(substitutions)
      if (typeof this.translatedCache[tmpKey] !== 'undefined') {
         return this.translatedCache[tmpKey]
      }

      const TRANSLATE_RX = RegExp("\%\{.*?\}")
      if(angular.isArray(text)) {
         for (let i = 0; i < text.length; i++) { var t = text[i]; text[i] = this.translate(t, substitutions) }
         translated = text
      } else {
         try {
            translated = this.lookup[text] || text
         } catch (e) {
            // if all else fails
            translated = text
         }
         if (TRANSLATE_RX.test(translated)) { translated = this.template(translated, substitutions) }
      }
      this.translatedCache[tmpKey] = translated
      return translated
   }

   template(tpl: any, substitutions: any) {
      for (var key in substitutions) {
         var value = substitutions[key]
         tpl = tpl.replace(new RegExp(`\%\{${key}\}`, "g"), value)
      }
      return tpl
   }
}

TranslationService.$inject = ['$translationKeys']

angular.module('summonApp.services')
   .service('translationService', TranslationService)
